document.addEventListener("DOMContentLoaded", function () {

    // Selectors
    var searchInput = document.getElementById("searchInput");
    var searchButton = document.getElementById("searchButton");

    // Search Variables
    var searchValue = searchInput ? searchInput.value : '';

    // Search Results
    var searchResults = document.querySelector(".search-result-list");

    // Pager Variables
    var pagerCon = document.querySelector(".paging");
    var pagerUrl = searchResults ? (searchResults.dataset.searchUrl || '') : '';
    var searchResultsList = searchResults ? searchResults.querySelector('ul') : null;
    var pagerPageSize = searchResultsList ? parseInt(searchResultsList.dataset.searchPagesize || '0', 10) : 0;
    var pagerFullCount = searchResultsList ? parseInt(searchResultsList.dataset.searchFullCount || '0', 10) : 0;
    var pagerPage = searchResultsList ? parseInt(searchResultsList.dataset.searchPage || '0', 10) : 0;

    // Generate pager
    RebuildPager();

    // Reset the news when the search button is clicked
    if (searchButton) searchButton.addEventListener('click', function () { ResetSearch(); });

    // Resets the news back to the first page which is triggered when a search is done
    function ResetSearch() {
        // Update the search items
        searchValue = searchInput ? searchInput.value : '';

        // Update the pager
        if (searchResults) searchResults.dataset.searchPage = '0';
        pagerPage = 0;

        // Update the click
        SearchUpdate(0);
    }

    // Updates the news items based on current values
    function SearchUpdate(pagerPageTemp) {
        var url = pagerUrl + "?api=true" +
            (pagerPageTemp > 0 ? "&page=" + pagerPageTemp : "") +
            (pagerPageSize > 0 ? "&pagesize=" + pagerPageSize : "") +
            (searchValue != undefined && searchValue != "" ? "&search=" + encodeURIComponent(searchValue) : "");

        fetch(url).then(function(resp){ return resp.text(); }).then(function(data){
            // Add the returned information to the search results list.
            if (searchResults) searchResults.innerHTML = data;

            // Reinitialise the variables based on the new list
            searchResultsList = document.querySelector('.search-result-list ul');
            pagerPageSize = searchResultsList ? parseInt(searchResultsList.dataset.searchPagesize || '0', 10) : pagerPageSize;
            pagerFullCount = searchResultsList ? parseInt(searchResultsList.dataset.searchFullCount || '0', 10) : pagerFullCount;
            pagerPage = searchResultsList ? parseInt(searchResultsList.dataset.searchPage || '0', 10) : pagerPage;

            // Update text content
            if (pagerFullCount > 0) {
                var showingFrom = (pagerPage * pagerPageSize) + 1;
                var showingTo = (pagerPage * pagerPageSize) + pagerPageSize;
                showingTo = showingTo > pagerFullCount ? pagerFullCount : showingTo;

                var info = document.querySelector('.SearchResults-info .text-results');
                if (info) info.innerHTML = 'Showing <Span>' + showingFrom + ' - ' + showingTo + '</Span> of ' + pagerFullCount;
                var formInfo = document.querySelector('.SearchResults-form .result-info');
                if (formInfo) formInfo.innerHTML = "<p>" + pagerFullCount + " results found for:<Span> '" + searchValue + "'</Span></p>";
                document.querySelectorAll('.SearchResults-body-row').forEach(function(el){ el.classList.remove('SearchResults-hidden'); });

            } else {
                var formInfo = document.querySelector('.SearchResults-form .result-info');
                if (formInfo) formInfo.innerHTML = '<p>Search returned no results for:<Span> \'' + searchValue + '\'</Span></p>';
                document.querySelectorAll('.SearchResults-body-row').forEach(function(el){ el.classList.add('SearchResults-hidden'); });
            }

            Check_if_in_view(); // Make sure we set this to show if there are little or no results
            Equalizer(); // Update equalizer
            RebuildPager();

            var bodyRow = document.querySelector('.SearchResults-body-row');
            if (bodyRow) {
                var top = bodyRow.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        }).catch(function(err){ console.error(err); });
    }

    function SearchFormSubmitted(e) {
        if (e.preventDefault) e.preventDefault();
        ResetSearch();
        return false;
    }

    var form = document.getElementById('searchForm');
    if (form) {
        if (form.attachEvent) {
            form.attachEvent("submit", SearchFormSubmitted);
        } else {
            form.addEventListener("submit", SearchFormSubmitted);
        }
    }

    /* ##### PAGER ##### */

    // Rebuilds the pager
    function RebuildPager() {

        // Clear the pager
        if (pagerCon) pagerCon.innerHTML = "";

        // Get the maximum pages
        var maxPages = Math.ceil(pagerFullCount / pagerPageSize);

        if (maxPages > 1) {
            if (pagerPage > 0) {
                pagerCon.innerHTML += "<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction\" data-search-page=\"" + (pagerPage - 1) + "\"><i class=\"far fa-angle-left\"></i></a></li>";
            } else {
                pagerCon.innerHTML += "<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction disabled\"><i class=\"far fa-angle-left\"></i></a></li>";
            }

            var startingNumber = pagerPage == 0 ? 0 : pagerPage - 1;
            startingNumber = pagerPage > 1 && pagerPage == (maxPages - 1) ? pagerPage - 2 : startingNumber;

            for (var pc = startingNumber; pc <= startingNumber + 2; pc++) {
                if (pc < maxPages) {
                    pagerCon.innerHTML += "<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link" + (pagerPage == pc ? " active" : "") + "\" data-search-page=\"" + pc + "\">" + (pc + 1) + "</a></li>";
                }
            }

            if (pagerPage < maxPages - 1) {
                pagerCon.innerHTML += "<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction\" data-search-page=\"" + (pagerPage + 1) + "\"><i class=\"far fa-angle-right\"></i></a></li>";
            } else {
                pagerCon.innerHTML += "<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction disabled\"><i class=\"far fa-angle-right\"></i></a></li>";
            }
        }

        // Rebind clicks
        if (pagerCon) {
            pagerCon.querySelectorAll('.page-link').forEach(function(el){ el.addEventListener('click', PageLinkClick); });
        }
    }

    // When a pager button is clicked
    function PageLinkClick(e) {
        // Turn on the overlay
        var overlay = document.querySelector('.search-list-wrapper .overlay'); if (overlay) overlay.classList.add('active');
        var pagerPageLink = this || e.currentTarget;
        var pagerPageTemp = pagerPageLink.dataset ? parseInt(pagerPageLink.dataset.searchPage || '0', 10) : 0;
        SearchUpdate(pagerPageTemp);
    }

});
